export enum Enviroment {
  Development = 'dev',
  Staging = 'test',
  Production = 'prod',
}
